import { currentTheme, DARK_META_COLOR, themeOption } from './theme';

export type ColorMode = 'light' | 'dark';
export const MODE_STORAGE_KEY = 'nailsly.mode';

const listeners = new Set<() => void>();

function readStoredMode(): ColorMode | null {
  try {
    const value = window.localStorage.getItem(MODE_STORAGE_KEY);
    return value === 'dark' || value === 'light' ? value : null;
  } catch {
    return null;
  }
}

function systemMode(): ColorMode {
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function currentMode(): ColorMode {
  return document.documentElement.getAttribute('data-mode') === 'dark' ? 'dark' : 'light';
}

function paintMeta(): void {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) return;
  meta.setAttribute('content', currentMode() === 'dark' ? DARK_META_COLOR : themeOption(currentTheme()).metaColor);
}

/** `persist: false` serve para aplicar o modo antes do React montar. */
export function applyMode(mode: ColorMode, persist = true): ColorMode {
  document.documentElement.setAttribute('data-mode', mode);
  paintMeta();
  if (persist) {
    try {
      window.localStorage.setItem(MODE_STORAGE_KEY, mode);
    } catch {
      /* navegação privada sem localStorage: o modo ainda vale nesta aba */
    }
  }
  listeners.forEach((listener) => listener());
  return mode;
}

export function toggleMode(): ColorMode {
  return applyMode(currentMode() === 'dark' ? 'light' : 'dark');
}

/** Usa o modo salvo ou, sem escolha do visitante, o do sistema operacional. */
export function bootMode(): ColorMode {
  return applyMode(readStoredMode() ?? systemMode(), false);
}

export function subscribeMode(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
